module.exports = __webpack_public_path__ + "media/images/lb/739-4fd6455c1da98a4c4b7041697f66a15f.svg";